const Lang = require('lang');

/**
 * Classe Genérica de Gráficos
 */
class GenericGraphic {

  constructor(data) {
    this.data = data;
    this.colorBorder = [];
    this.labels = [];
    this.dataSet = [];
  }

  /**
   * Cores para ser utilizadas nos gráficos
   * @return {[type]} [description]
   */
  colors() {
    const colors =  [
      'rgba(0, 157, 179, .8)',
      'rgba(191,58,106, .8)',
      'rgba(49,255,59, .8)',
      'rgba(255,75,52, .8)',
      'rgba(50,33,127, .8)',
      'rgba(191,191,56, .8)',
      'rgba(86,127,107, .8)',
      'rgba(255,134,21, .8)',
      'rgba(30,127,122, .8)',
      'rgba(127,35,127, .8)'
    ];
    return colors;
  }

  /**
   * Preparar dados para serem vinculados aos
   * gráficos, utilizado para os gráficos comuns
   *
   * @param  {int} limit
   * @param  {bool} sum
   */
  prepareDataGraphicCommon(limit = null, sum) {
    let i = 1;
    let soma = 0;
    if (limit !== null && this.data.length > limit) {
      this.data.forEach((current) =>  {
        // adicionadno diretamente a label e o valor
        // ao dataSet se o indice for menor que o limit
        if (i < limit) {
          this.labels.push(current.label);
          this.dataSet.push(current.valor);
        }
        // Se o limite for ultrapassado e a variável soma
        // estiver habilitada inicia a soma de todos os valores
        // que vem a seguir
        if (i >= limit && sum == true) {
          current.valor = parseFloat(current.valor);
          soma = parseFloat(soma) + parseFloat(current.valor);
        }
        i++;
      });
      // Se a soma for true adicioan o valor e
      // a label ao dataSet
      if (sum == true) {
        this.labels.push(Lang.get('js/src/classes/Graphics.others'));
        this.dataSet.push(soma);
      }
      return;
    }
    // Caso não exista um limit informado percorre
    // todos os dados adicionando ao dataSet
    this.data.forEach((current) =>  {
      if (current.valor > 0) {
        this.labels.push(current.label);
        this.dataSet.push(current.valor);
      }
    });
  }
}

export default GenericGraphic;
